import React from "react";
import { AuditLog, AuditLogDiff } from "@common/types/auditLog";
import { Amount } from "@design-system/Amount/Amount";
import { parseISO } from "date-fns";
import { AuditLogItem } from "../AuditLogItem";
import { BankReconciliationLogType } from "./BankReconciliationLogItem.lib";

interface BankReconciliationLogItemProps {
    log: AuditLog;
    type: BankReconciliationLogType;
}

export const BankReconciliationLogItem: React.FC<
    BankReconciliationLogItemProps
> = ({ log, type }) => {
    const createdAtDate = parseISO(log.createdAt.toString());

    const balance = React.useMemo(() => {
        const fieldName =
            type === BankReconciliationLogType.CREATED
                ? "openingBalance"
                : "closingBalance";
        const balanceField = log.diff?.find(
            (d: AuditLogDiff) => d.field === fieldName,
        );
        if (!balanceField?.after?.value) {
            return null;
        }
        const balanceValue = Number(balanceField.after.value);
        return isNaN(balanceValue) ? null : balanceValue;
    }, [log.diff, type]);

    const actionText =
        type === BankReconciliationLogType.CREATED ? "started" : "finished";
    const balanceLabel =
        type === BankReconciliationLogType.CREATED
            ? "opening balance"
            : "closing balance";

    return (
        <AuditLogItem
            actorId={log.actorId}
            actorName={log.actorName}
            actorType={log.actorType}
            timestamp={createdAtDate}
        >
            <span> {actionText} reconciliation</span>
            {balance !== null && (
                <>
                    <span> with {balanceLabel}: </span>
                    <Amount
                        amount={balance}
                        separateCurrencySign
                        showNegative
                    />
                </>
            )}
        </AuditLogItem>
    );
};
